/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { PureComponent } from 'react'
import { Form, Input } from 'semantic-ui-react'

export default class CommissionField extends PureComponent {
  render() {
    const { value, onChange, field, required, disabled } = this.props

    return (
      <Form.Field required={required}>
        <label>Commission Rate</label>
        <Input
          disabled={disabled}
          label={{ content: '%' }}
          labelPosition="right"
          placeholder="e.g 10"
          type="number"
          min="0"
          required={required}
          onChange={e => onChange(field, e.target.value)}
          value={value}
        />
      </Form.Field>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/commissionField.js